import React, { forwardRef } from 'react'

import type { FlowLayoutNode, NodeRenderProps } from '../types'
import type { FlowLayoutBaseNodeProps } from './BaseNode'
import { BaseNode } from './BaseNode'
import type { FlowLayoutContainerNodeProps } from './ContainerNode'
import { ContainerNode } from './ContainerNode'
import type { FlowLayoutCustomNodeProps } from './CustomNode'
import { CustomNode } from './CustomNode'
import { OverlayNode } from './OverlayNode'

export interface FlowLayoutNodeProps extends React.ComponentPropsWithoutRef<'div'> {
    data: FlowLayoutNode
    disabled?: boolean
    extra?: React.ReactNode
    nodeRender?: (props: NodeRenderProps) => JSX.Element | null
}
export const Node = forwardRef<HTMLDivElement, FlowLayoutNodeProps>((props, ref) => {
    switch (props.data.type) {
        case 'container':
        case 'formContainer': {
            return <ContainerNode {...(props)} ref={ref} />
        }

        case 'block': {
            return <BaseNode {...(props)} ref={ref} />
        }

        case 'custom': {
            return <CustomNode {...(props)} ref={ref} />
        }

        case 'overlay': {
            return <OverlayNode {...(props)} ref={ref} />
        }

        default: {
            return null
        }
    }
})
